import React, { useState, useEffect, useContext } from "react";
import "./Votes.scss";
import NumberFormat from "react-number-format";
import { ToggleButton, ButtonGroup, Table } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { ProgressBar } from "react-bootstrap";

import { UserContext } from "../../api/user/userContext";
import { EmotIcons } from "../../api/ReplayVariables";

function Votes({ hand, onLogin, onVoted, preview = false, featured = false }) {
  const { user } = useContext(UserContext);
  const [ready, setReady] = useState(false);

  const voteChanged = (value) => {
    if (value.currentTarget.value !== hand.vote) {
      if (user !== null && user.id > 0) {
        setReady(false);
        const requestOptions = {
          method: "POST",
          headers: { "Content-Type": "application/x-www-form-urlencoded" },
          body: "id=" + hand.id + "&vote=" + value.currentTarget.value
        };
        fetch(window.serverUrl+`/social/vote.php`, requestOptions)
          .then((r) => r.json())
          .then((resp) => {
            if (resp.error === 401) {
              onLogin();
            } else if (resp.error === 404) {
              setReady(true);
            } else {
              onVoted(resp);
            }
          })
          .catch((err) => {
            console.error("fetch problem", err);
            setReady(true);
          });
      } else {
        onLogin();
      }
    }
  };

  const { t } = useTranslation();

  useEffect(() => {
    setReady((r) => false);
    let timer = setTimeout(() => {
      setReady((r) => true);
    }, 500);
    return () => {
      clearTimeout(timer);
    };
  }, [user, hand]);

  return (
    <>
      {!preview ? (
        <div className="votes d-flex flex-column">
          {!featured ? (
            <div className="vote d-flex flex-row align-items-center">
              <div className="actions">
                <ButtonGroup toggle className="mb-2">
                  <ToggleButton
                    key={1}
                    type="checkbox"
                    disabled={!ready}
                    value={0}
                    checked={hand.vote === 0}
                    onChange={voteChanged}
                  >
                    <img
                      src={
                        hand.vote === 0
                          ? EmotIcons.VOTE0
                          : EmotIcons.VOTE0DISABLED
                      }
                      alt=""
                    />
                    <span>{t("replayApp.votes.0")}</span>
                  </ToggleButton>
                  <ToggleButton
                    key={2}
                    type="checkbox"
                    disabled={!ready}
                    value={1}
                    checked={hand.vote === 1}
                    onChange={voteChanged}
                  >
                    <img
                      src={
                        hand.vote === 1
                          ? EmotIcons.VOTE1
                          : EmotIcons.VOTE1DISABLED
                      }
                      alt=""
                    />
                    <span>{t("replayApp.votes.1")}</span>
                  </ToggleButton>
                  <ToggleButton
                    key={3}
                    type="checkbox"
                    disabled={!ready}
                    value={2}
                    checked={hand.vote === 2}
                    onChange={voteChanged}
                  >
                    <img
                      src={
                        hand.vote === 2
                          ? EmotIcons.VOTE2
                          : EmotIcons.VOTE2DISABLED
                      }
                      alt=""
                    />
                    <span>{t("replayApp.votes.2")}</span>
                  </ToggleButton>
                  <ToggleButton
                    key={4}
                    type="checkbox"
                    disabled={!ready}
                    value={3}
                    checked={hand.vote === 3}
                    onChange={voteChanged}
                  >
                    <img
                      src={
                        hand.vote === 3
                          ? EmotIcons.VOTE3
                          : EmotIcons.VOTE3DISABLED
                      }
                      alt=""
                    />
                    <span>{t("replayApp.votes.3")}</span>
                  </ToggleButton>
                  <ToggleButton
                    key={5}
                    type="checkbox"
                    disabled={!ready}
                    value={4}
                    checked={hand.vote === 4}
                    onChange={voteChanged}
                  >
                    <img
                      src={
                        hand.vote === 4
                          ? EmotIcons.VOTE4
                          : EmotIcons.VOTE4DISABLED
                      }
                      alt=""
                    />
                    <span>{t("replayApp.votes.4")}</span>
                  </ToggleButton>
                </ButtonGroup>
              </div>
            </div>
          ) : (
            <></>
          )}
          <div className="vote-summary d-flex flex-column">
            <Table className="vote-detail">
              <tbody>
                {[1, 2, 3, 4].map((voteNum) => (
                  <tr
                    key={hand.id + "-" + voteNum}
                    className={"vote" + voteNum}
                  >
                    <td>
                      {
                        <img
                          src={
                            hand["vote" + voteNum] > 0
                              ? EmotIcons["VOTE" + voteNum]
                              : EmotIcons["VOTE" + voteNum + "DISABLED"]
                          }
                          alt=""
                        />
                      }
                    </td>
                    <td className="vote-name">
                      {t("replayApp.votes." + voteNum)}
                    </td>
                    <td width="100%">
                      <ProgressBar
                        now={
                          hand.votes > 0
                            ? (hand["vote" + voteNum] * 100) / hand.votes
                            : 0
                        }
                      ></ProgressBar>
                    </td>
                    <td className="percentage">
                      {hand.votes > 0 ? (
                        <NumberFormat
                          value={(hand["vote" + voteNum] * 100) / hand.votes}
                          displayType={"text"}
                          decimalScale="1"
                          renderText={(value) => <>{value} %</>}
                        />
                      ) : (
                        "0 %"
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
            <div className="vote-detail-small d-flex">
              {[1, 2, 3, 4].map((voteNum) => (
                <div
                  key={voteNum}
                  className="d-flex flex-column align-items-center"
                >
                  <div
                    key={hand.id + "-" + voteNum}
                    className={"vote" + voteNum}
                  >
                    <img
                      src={
                        hand["vote" + voteNum] > 0
                          ? EmotIcons["VOTE" + voteNum]
                          : EmotIcons["VOTE" + voteNum + "DISABLED"]
                      }
                      alt=""
                    />
                  </div>
                  <div className="percentage">
                    {hand.votes > 0 ? (
                      <NumberFormat
                        value={(hand["vote" + voteNum] * 100) / hand.votes}
                        displayType={"text"}
                        decimalScale="1"
                        renderText={(value) => <>{value} %</>}
                      />
                    ) : (
                      "0 %"
                    )}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      ) : (
        <div className="votes preview-votes d-flex">
          {[1, 2, 3, 4].map((voteNum) => (
            <div
              key={hand.id + "-" + voteNum}
              className={"percentage vote" + voteNum}
              style={{
                width:
                  (hand.votes > 0
                    ? (hand["vote" + voteNum] * 100) / hand.votes
                    : 0) + "%"
              }}
            >
              &nbsp;
            </div>
          ))}
        </div>
      )}
    </>
  );
}

export default Votes;
